<template>

	<div id="context">
		<remote-script :src="'https://webapi.amap.com/maps?v=1.4.12&key=4bde7b8be905b4e172bfd5bfcadbda18&plugin=AMap.Walking'" ></remote-script>
		<div id="container"></div>
		<div id="panel"></div>
	</div>
</template>


<script>
	export default {
		data() {
			return {
				lLocation: 104.714639,
				rLocation: 28.444777
			}
		},
		mounted: function() {
			var map = new AMap.Map("container", {
				resizeEnable: true,
				// center: [this.lLocation, this.rLocation],//地图中心点
				zoom: 16 //地图显示的缩放级别
			});
			
			 AMap.plugin('AMap.Geolocation', function() {
				var geolocation = new AMap.Geolocation({
					enableHighAccuracy: true,//是否使用高精度定位，默认:true
					timeout: 10000,          //超过10秒后停止定位，默认：5s
					buttonPosition:'RB',    //定位按钮的停靠位置
					buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
					zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
					});	
					
				geolocation.getCurrentPosition();
				map.addControl(geolocation);
			 });
			
			this.$http.get('company/AllCompanyLocation','')
			.then((res)=> {
					let markers=[];
					for(let i=0;i<res.data.length;i++){
						if(res.data[i].clongitude==''||res.data[i].clatitude=='') continue;
						res.data[i].clongitude=parseFloat(res.data[i].clongitude);
						res.data[i].clatitude=parseFloat(res.data[i].clatitude);
						markers.push({
							position: [res.data[i].clongitude, res.data[i].clatitude],
							icon:res.data[i].ctName=='主管部门'?require('../../../../assets/image/manager.png'):res.data[i].ctName=='医院'?require('../../../../assets/image/hospital_jj.png'):require('../../../../assets/image/hospital_wsy.png')
						});
					}
					
					markers.forEach(function(marker) {
						new AMap.Marker({
							map: map,
							icon: marker.icon,
							position: [marker.position[0],marker.position[1]]
						});
					});
			});
		},
		methods: {},
		computed: {
			position: function() {
				return new AMap.LngLat(this.lLocation, this.rLocation);
			}
		}
	}
</script>
<style>
	#context,
	#container {
		height: 100%;
		width: 100%;
	}

	.custom-content-marker {
		position: relative;
		width: 25px;
		height: 34px;
	}

	.custom-content-marker img {
		width: 100%;
		height: 100%;
	}

	.custom-content-marker .close-btn {
		position: absolute;
		top: -6px;
		right: -8px;
		width: 15px;
		height: 15px;
		font-size: 12px;
		background: #ccc;
		border-radius: 50%;
		color: #fff;
		text-align: center;
		line-height: 15px;
		box-shadow: -1px 1px 1px rgba(10, 10, 10, .2);
	}

	.custom-content-marker .close-btn:hover {
		background: #666;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/WeChat/Map/index.vue